/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_13 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElIcon as __unplugin_components_12 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_11 from '~icons/ep/document-copy';
import { ElTooltip as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/tooltip/style/css';
import { ElTag as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElCard as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/card/style/css';
import { ElRow as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/row/style/css';
import { ElCol as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/col/style/css';
import { ElButton as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElSelect as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElInput as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/drone/src/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索");
const _hoisted_2 = {
  class: "text-right marginT20 marginB20"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode("官方分包");
const _hoisted_4 = /*#__PURE__*/_createTextVNode("导出");
const _hoisted_5 = /*#__PURE__*/_createTextVNode("批量发布cdn");
const _hoisted_6 = /*#__PURE__*/_createTextVNode("定时任务列表");
const _hoisted_7 = /*#__PURE__*/_createTextVNode("批量禁用");
const _hoisted_8 = /*#__PURE__*/_createTextVNode("使用中");
const _hoisted_9 = /*#__PURE__*/_createTextVNode("禁用中");
const _hoisted_10 = /*#__PURE__*/_createTextVNode("打包时间: ");
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" CDN链接 ");
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "CDN下载链接说明：", -1);
const _hoisted_16 = /*#__PURE__*/_createElementVNode("ul", null, [/*#__PURE__*/_createElementVNode("li", null, "1、当您需要给玩家提供下载链接时，则可发布CDN；"), /*#__PURE__*/_createElementVNode("li", null, "2、注意CDN地址可以对外给玩家下载，外网取包则不可提供给玩家进行下载用否则会造成服务器拥堵而出现下载失败的情况；")], -1);
const _hoisted_17 = /*#__PURE__*/_createTextVNode("CDN定时发布中");
const _hoisted_18 = /*#__PURE__*/_createTextVNode("发布CDN");
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = /*#__PURE__*/_createTextVNode("重试");
const _hoisted_21 = /*#__PURE__*/_createTextVNode("更多");
import { useAppStore } from '@/store/modules/app';
import { cdnStatus, cdnStatusList, columns, packStatusList, statusList } from './constants';
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiProjectGetStaticData, apiUsdkCpsForbid, apiUsdkCpsPackagesList } from '@/api/usdk';
import UQuestion from '@ultra/share/components/UQuestion/index.vue';
import PublishCdnDialog from './publishCdnDialog.vue';
import ConsTaskDialog from './consTaskDialog.vue';
import CreatePack from './createPack.vue';
import { copyText } from '@ultra/share/utils';
import { useTaskStore } from '@/store/modules/downTask';
import SubPackageConf from '@/views/operate/officialPackage/officialSubPackage/subPackageConf.vue';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const gameInfo = computed(() => useAppStore().gameInfo);
    const filter = ref({
      gid: undefined,
      status: 1,
      cid: undefined,
      cdnStatus: undefined,
      pkgStatus: undefined,
      name: '',
      projectId: '',
      model: 0,
      distributeChannelId: -1
    });
    const distributeChannelList = ref([]);
    const publishCdnDialogRef = ref();
    const consTaskDialogRef = ref();
    const subPkgConfRef = ref();
    const createPackRef = ref();
    const multipleSelect = ref([]);
    const staticData = ref({
      pkgFail: 0,
      cdnFail: 0
    });
    const handleSuccess = () => {
      getTableData();
      getStaticData();
    };
    const getTableData = () => {
      const params = {
        ...filter.value,
        pageNumber: current.value,
        pageSize: pageSize.value
      };
      tableLoading.value = true;
      apiUsdkCpsPackagesList(params).then(res => {
        if (res.data && res.data.list) {
          tableData.value = res.data.list;
          total.value = res.data.totalRow;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const getStaticData = () => {
      const params = {
        gid: gameInfo.value.Id
      };
      apiProjectGetStaticData(params).then(res => {
        console.log('object', res);
        if (res.code === 0) {
          staticData.value = res.data;
        }
      });
    };
    // cdnType: 1-单个发布cdn,发布失败重新发cdn;2-批量发布cdn;3-编辑发布cdn;
    const handlePublishCdn = (type, data) => {
      publishCdnDialogRef.value.show(type, data);
    };
    const handleBatchPublishCdn = () => {
      publishCdnDialogRef.value.show(2, null, multipleSelect.value);
    };
    const handleShowAddModal = () => {
      createPackRef.value.show();
    };
    // 多选赋值
    const handleMultipleSelect = val => {
      multipleSelect.value = val;
    };
    // 批量禁用
    const batchDisableProject = () => {
      ElMessageBox.confirm('确定禁用所选项目？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          ids: multipleSelect.value.map(item => item.id).join(','),
          status: 0
        };
        apiUsdkCpsForbid(params).then(res => {
          if (res.code === 0) {
            getTableData();
            getStaticData();
          }
        });
      }).catch(() => {
        console.log('取消');
      });
    };
    const downloadPackage = data => {
      let url = data.cdnUrl;
      copyText(url).then(() => {
        ElMessage.success('复制成功');
      }).catch(() => {
        ElMessage.error('复制失败');
      });
    };
    const handleRepackage = data => {
      console.log('object');
    };
    // 启用/禁用项目
    const toggleProject = data => {
      ElMessageBox.confirm(`是否${data.status === 0 ? '启用' : '禁用'}该项目`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apiUsdkCpsForbid({
          ids: data.id,
          status: data.status ? 0 : 1
        }).then(res => {
          if (res.code === 0) {
            getTableData();
          }
        });
      }).catch(() => {
        console.log('取消');
      });
    };
    const {
      setTask
    } = useTaskStore();
    const handleExport = () => {
      const params = {
        ...filter.value
      };
      setTask({
        api: apiUsdkCpsPackagesList,
        page: 'pageNumber',
        pageSize: 'pageSize',
        params,
        data: 'data.list',
        total: 'data.totalRow',
        excel: {
          title: `${gameInfo.value.Name}-渠道分包列表`,
          header: ['游戏名称', '分包来源', '分发渠道', '项目ID', '项目名称', 'CDN地址', '自适配地址', '分官网链接'],
          field: ['gameName', 'originChannel', 'distributeName', 'projectId', 'name', 'cdnUrl', 'shortUrl', 'officialUrl']
        }
      });
    };
    // 打开定时任务弹窗
    const handleCronTask = () => {
      consTaskDialogRef.value.show(gameInfo.value);
    };
    const showSubPkg = item => {
      subPkgConfRef.value.onShow(item);
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        filter.value.gid = val.Id;
        getTableData();
        getStaticData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_GameChannelSelect = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_input = __unplugin_components_2;
      const _component_el_option = __unplugin_components_3;
      const _component_el_select = __unplugin_components_4;
      const _component_el_button = __unplugin_components_5;
      const _component_el_col = __unplugin_components_6;
      const _component_el_row = __unplugin_components_7;
      const _component_el_card = __unplugin_components_8;
      const _component_el_tag = __unplugin_components_9;
      const _component_el_tooltip = __unplugin_components_10;
      const _component_i_ep_DocumentCopy = __unplugin_components_11;
      const _component_el_icon = __unplugin_components_12;
      const _component_el_form = __unplugin_components_13;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_form, {
        class: "marginT20",
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "分包来源"
        }, {
          default: _withCtx(() => [_createVNode(_component_GameChannelSelect, {
            modelValue: filter.value.cid,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filter.value.cid = $event),
            gid: _unref(gameInfo).Id,
            otherProps: {
              isHero: 1,
              needIos: 0
            },
            onChange: getTableData
          }, null, 8, ["modelValue", "gid"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "项目名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: filter.value.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filter.value.name = $event),
            placeholder: "请输入项目名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "项目ID"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: filter.value.projectId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filter.value.projectId = $event),
            placeholder: "请输入项目ID"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "打包状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: filter.value.pkgStatus,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filter.value.pkgStatus = $event),
            clearable: "",
            placeholder: "选择打包状态"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(packStatusList), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "投放状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: filter.value.status,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => filter.value.status = $event),
            placeholder: "选择投放状态"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusList), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "CDN发布状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: filter.value.cdnStatus,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => filter.value.cdnStatus = $event),
            clearable: "",
            placeholder: "选择CDN发布状态"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cdnStatusList), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "分发渠道"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: filter.value.distributeChannelId,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => filter.value.distributeChannelId = $event),
            placeholder: "选择分发渠道"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              value: -1,
              label: "全部"
            }), _createVNode(_component_el_option, {
              value: 0,
              label: "自己"
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distributeChannelList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: getTableData
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_card, {
          shadow: "never"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 6,
              style: {
                "color": "#f5222d",
                "font-size": "14px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode("打包失败：" + _toDisplayString(staticData.value.pkgFail), 1)]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 6,
              style: {
                "color": "#f5222d",
                "font-size": "14px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode("CDN发布失败： " + _toDisplayString(staticData.value.cdnFail), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleShowAddModal
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "marginL10",
          type: "primary",
          onClick: handleExport
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          disabled: multipleSelect.value.length === 0,
          class: "marginL10",
          type: "primary",
          onClick: handleBatchPublishCdn
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          class: "marginL10",
          type: "primary",
          onClick: handleCronTask
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_el_button, {
          disabled: multipleSelect.value.length === 0,
          class: "marginL10",
          type: "primary",
          onClick: batchDisableProject
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }, 8, ["disabled"])]), _createVNode(UTable, {
          "current-page": _unref(current),
          data: _unref(tableData),
          loading: _unref(tableLoading),
          options: _unref(columns),
          "page-size": _unref(pageSize),
          total: _unref(total),
          "is-multiple": "",
          pagination: "",
          onSizeChange: _unref(handleSizeChange),
          onCurrentChange: _unref(handleCurrentChange),
          onMultipleSelect: handleMultipleSelect
        }, {
          status: _withCtx(({
            scope
          }) => [scope.row.status == 1 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0
          }, {
            default: _withCtx(() => [_hoisted_8]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_tag, {
            key: 1,
            type: "info"
          }, {
            default: _withCtx(() => [_hoisted_9]),
            _: 1
          }))]),
          packageInfo: _withCtx(({
            scope
          }) => [_createElementVNode("div", null, "versionname: " + _toDisplayString(scope.row.packageInfo ? 'v' + scope.row.packageInfo.verName : '-'), 1), _createElementVNode("div", null, "versioncode: " + _toDisplayString(scope.row.packageInfo ? scope.row.packageInfo.verCode : ''), 1), _createElementVNode("div", null, "SDK: " + _toDisplayString(scope.row.packageInfo ? scope.row.packageInfo.sdkVersion : '-'), 1), _createElementVNode("div", null, [_hoisted_10, scope.row.packageInfo && scope.row.packageInfo.pkgTime ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(scope.row.packageInfo.pkgTime), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))])]),
          pkgStatusText: _withCtx(({
            scope
          }) => [scope.row.packageInfo ? (_openBlock(), _createElementBlock("div", _hoisted_13, [scope.row.pkgStatus === 3 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "danger"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tooltip, null, {
              content: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.pkgFailText), 1)]),
              default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(scope.row.pkgStatusText), 1)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)) : scope.row.pkgStatus === 4 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 1,
            type: "success"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.pkgStatusText), 1)]),
            _: 2
          }, 1024)) : (_openBlock(), _createBlock(_component_el_tag, {
            key: 2,
            type: "info"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.pkgStatusText), 1)]),
            _: 2
          }, 1024))])) : _createCommentVNode("", true)]),
          cdnUrlHeader: _withCtx(() => [_createElementVNode("div", null, [_hoisted_14, _createVNode(UQuestion, null, {
            default: _withCtx(() => [_hoisted_15, _hoisted_16]),
            _: 1
          })])]),
          cdnUrl: _withCtx(({
            scope
          }) => [scope.row.cdnStatus === 5 && scope.row.cdnTime ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            size: "small",
            style: {
              "color": "#faad14"
            },
            type: "primary",
            onClick: $event => handlePublishCdn(3, scope.row)
          }, {
            default: _withCtx(() => [_hoisted_17]),
            _: 2
          }, 1032, ["onClick"])) : scope.row.cdnStatus == 0 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            link: "",
            size: "small",
            type: "primary",
            onClick: $event => handlePublishCdn(1, scope.row)
          }, {
            default: _withCtx(() => [_hoisted_18]),
            _: 2
          }, 1032, ["onClick"])) : scope.row.packageInfo ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 2,
            type: _unref(cdnStatus)[scope.row.cdnStatus].color
          }, {
            default: _withCtx(() => [scope.row.cdnFelilText ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              content: scope.row.cdnStatusText,
              title: scope.row.cdnFailText
            }, null, 8, ["content", "title"])) : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(scope.row.cdnStatusText), 1))]),
            _: 2
          }, 1032, ["type"])) : _createCommentVNode("", true), scope.row.cdnStatus == 3 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            class: "marginL10",
            link: "",
            size: "small",
            type: "primary",
            onClick: $event => handlePublishCdn(1, scope.row)
          }, {
            default: _withCtx(() => [_hoisted_20]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), scope.row.cdnStatus == 4 ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 4,
            class: "marginL10 cp",
            onClick: $event => downloadPackage(scope.row)
          }, {
            default: _withCtx(() => [_createVNode(_component_i_ep_DocumentCopy)]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
          action: _withCtx(({
            scope
          }) => [_createVNode(_component_el_button, {
            link: "",
            size: "small",
            type: "primary",
            onClick: $event => showSubPkg(scope.row)
          }, {
            default: _withCtx(() => [_hoisted_21]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            style: _normalizeStyle(scope.row.status == 1 ? {
              color: '#ff4d4f'
            } : ''),
            link: "",
            size: "small",
            type: "primary",
            onClick: $event => toggleProject(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.status == 1 ? '禁用' : '启用'), 1)]),
            _: 2
          }, 1032, ["style", "onClick"])]),
          _: 1
        }, 8, ["current-page", "data", "loading", "options", "page-size", "total", "onSizeChange", "onCurrentChange"])]),
        _: 1
      }), _createVNode(SubPackageConf, {
        ref_key: "subPkgConfRef",
        ref: subPkgConfRef,
        onSuccess: handleSuccess
      }, null, 512), _createVNode(PublishCdnDialog, {
        ref_key: "publishCdnDialogRef",
        ref: publishCdnDialogRef,
        onSuccess: handleSuccess
      }, null, 512), _createVNode(ConsTaskDialog, {
        ref_key: "consTaskDialogRef",
        ref: consTaskDialogRef,
        onSuccess: handleSuccess
      }, null, 512), _createVNode(CreatePack, {
        ref_key: "createPackRef",
        ref: createPackRef,
        gid: _unref(gameInfo).Id,
        onSuccess: handleSuccess
      }, null, 8, ["gid"])], 64);
    };
  }
});